import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQAccordion() {
  const faqs = [{
    question: 'What is the KS3 Maths Research Study?',
    answer: 'This is a large-scale Randomised Controlled Trial (RCT) partnering with UK schools to evaluate how Eedi supports KS3 students in overcoming misconceptions and achieving lasting progress in mathematics. Schools will implement Eedi in randomly selected classes while others serve as comparison groups to measure impact.'
  }, {
    question: 'Who can join the study?',
    answer: 'We are looking for secondary state schools in the United Kingdom with KS3 maths classes. Schools need to be willing to have classes randomly assigned to either use Eedi or serve as control groups for the duration of the academic year.'
  }, {
    question: 'How much time does participation require?',
    answer: 'Participating schools should aim for weekly Eedi usage in intervention classrooms (approximately 20-30 minutes per session). All students will need to complete three STAR maths assessments during the year (around 30 minutes each, during class time). Eedi will support the setup of all assessments.'
  }, {
    question: "What's the financial commitment for schools?",
    answer: 'There is no cost to participate. Schools receive financial compensation for their participation in the research study, plus free access to Eedi Plus and STAR assessments worth thousands of pounds.'
  }, {
    question: 'What is the duration of the study?',
    answer: "The research study is a one-year commitment, running from September 2026 to July 2027. During this period, intervention classes will engage with Eedi's platform while control classes continue with business-as-usual teaching. All classes will complete the assessment measures."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-24">
      {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 last:border-b-0" data-id="element-25">
          <button className="flex justify-between items-center w-full px-6 py-4 text-left" onClick={() => toggleFAQ(index)} data-id="element-26">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-27">
              {faq.question}
            </h3>
            <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-28" />
          </button>
          <div className={`px-6 overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-29">
            <p className="text-gray-700" data-id="element-30">{faq.answer}</p>
          </div>
        </div>)}
    </div>;
}